import React from "react";

import {
  OptionEnum,
  OptionModeEnum,
  OptionTypeEnum,
} from "@/components/Option";

import { Flexbox, Result, Text, WhiteBox } from "./styles";

export type ResultBarProps = {
  mode: OptionModeEnum;
  type: OptionTypeEnum;
  percent?: number;
  answer?: OptionEnum;
  isSecret?: boolean;
};

export type ResultBarState = {};

export class ResultBar extends React.Component<ResultBarProps, ResultBarState> {
  public render(): JSX.Element {
    const { answer, percent, mode, type, isSecret } = this.props;
    return (
      <WhiteBox>
        <Flexbox {...this.props}>
          <Result
            mode={mode}
            type={type}
            percent={mode === OptionModeEnum.normal ? 0 : percent} // css transition
            answer={answer}
            isSecret={isSecret}
          />
          {!isSecret && mode === OptionModeEnum.results && (
            <Text {...this.props}>
              {typeof percent === "number" ? `${percent}%` : ""}
            </Text>
          )}
        </Flexbox>
      </WhiteBox>
    );
  }
}
